var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"tw-prose-a:text-link tw-prose tw-max-w-none tw-text-left",attrs:{"title":_setup.expandDescription ? 'Click to hide full description' : 'Click to expand full description'}},[_c('div',{ref:"textRef",class:{
      safari: _setup.isSafari,
      'tw-line-clamp-1': !_setup.expandDescription && _vm.lineClamp === 1,
      'tw-line-clamp-2': !_setup.expandDescription && _vm.lineClamp === 2,
      'tw-line-clamp-3': !_setup.expandDescription && _vm.lineClamp === 3,
      'tw-line-clamp-4': !_setup.expandDescription && _vm.lineClamp === 4,
      'tw-line-clamp-5': !_setup.expandDescription && _vm.lineClamp === 5,
      'tw-line-clamp-none': !_setup.expandDescription && _vm.lineClamp === 'none',
    },domProps:{"innerHTML":_vm._s(_setup.transformedDescription)}}),_vm._v(" "),_c('div',{class:{
      'tw-invisible -tw-mt-4': _setup.expansionNotRequired,
      'less-link -tw-mt-4': _setup.expandDescription,
      'more-link': !_setup.expandDescription,
    },on:{"click":function($event){$event.preventDefault();_setup.expandDescription = !_setup.expandDescription}}},[_vm._v("\n    "+_vm._s(_setup.expandDescription ? 'Show less' : 'Show more')+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }